export default __webpack_public_path__ + "static/media/ted.3f08effb.png";